var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isShow,
            expression: "!isShow"
          }
        ],
        staticClass: "main-content"
      },
      [
        _c(
          "div",
          {
            staticClass: "section operations triggers",
            staticStyle: { height: "39px" }
          },
          [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      disabled: _vm.banned === 0,
                      size: "mini"
                    },
                    on: { click: _vm.buttonDetails }
                  },
                  [_vm._v(_vm._s(_vm.$t("Clearing.ViewDetails")))]
                )
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "config-module": "20220607",
                "grid-params": _vm.gridParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                },
                gridReady: function(params) {
                  _vm.gridApi = params.api
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("cargo-pagination", {
              attrs: {
                "config-module": "41001220014",
                total: _vm.filter.total,
                page: _vm.filter.pageNum,
                limit: _vm.filter.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.filter, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.filter, "pageSize", $event)
                },
                pagination: _vm.toQuery
              }
            })
          ],
          1
        )
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShow,
            expression: "isShow"
          }
        ],
        staticClass: "main-content historical-details"
      },
      [
        _c("div", { staticClass: "section operations triggers" }, [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.toList }
                },
                [_vm._v(_vm._s(_vm.$t("Clearing.Return")))]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "footer-check" },
            [
              _c(
                "el-checkbox-group",
                {
                  on: { change: _vm.statusChanges },
                  model: {
                    value: _vm.checkList,
                    callback: function($$v) {
                      _vm.checkList = $$v
                    },
                    expression: "checkList"
                  }
                },
                [
                  _c("el-checkbox", { attrs: { label: "0" } }, [
                    _vm._v(_vm._s(_vm.$t("Clearing.ShowAllReconciliationFees")))
                  ]),
                  _c("el-checkbox", { attrs: { label: "1" } }, [
                    _vm._v(_vm._s(_vm.$t("Clearing.ShowFullyReconciledFees")))
                  ]),
                  _c("el-checkbox", { attrs: { label: "2" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("Clearing.ShowPartiallyReconciledFees"))
                    )
                  ]),
                  _c("el-checkbox", { attrs: { label: "3" } }, [
                    _vm._v(_vm._s(_vm.$t("Clearing.ShowUnmatchedFees")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("p", { staticClass: "instructions section" }, [
          _vm._v(" " + _vm._s(_vm.$t("Clearing.Note")) + " "),
          _c("span", { staticStyle: { color: "green" } }, [
            _vm._v(_vm._s(_vm.$t("Clearing.Green")))
          ]),
          _vm._v(
            _vm._s(
              _vm.$t("Clearing.IndicatesReconciliationResultIsConsistent")
            ) + " "
          ),
          _c("span", { staticStyle: { color: "#000" } }, [
            _vm._v(_vm._s(_vm.$t("Clearing.Black")))
          ]),
          _vm._v(
            _vm._s(_vm.$t("Clearing.IndicatesCorrespondingFeeNotFound")) + " "
          ),
          _c("span", { staticStyle: { color: "red" } }, [
            _vm._v(_vm._s(_vm.$t("Clearing.Red")))
          ]),
          _vm._v(_vm._s(_vm.$t("Clearing.IndicatesAmountInconsistency")) + " "),
          _c("span", { staticStyle: { color: "orange" } }, [
            _vm._v(_vm._s(_vm.$t("Clearing.Orange")))
          ]),
          _vm._v(
            _vm._s(_vm.$t("Clearing.IndicatesManualReconciliationCompleted")) +
              " "
          )
        ]),
        _c("div", { staticClass: "details-list grid-wrapper" }, [
          _c("div", { staticClass: "details-content grid-wrapper" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("Clearing.ImportExternalFees")))
                ]),
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "2022061601",
                    "grid-options": _vm.externalGridOptions,
                    "column-defs": _vm.externalColumnDefs,
                    "row-data": _vm.externalData
                  }
                }),
                _c("div", { staticClass: "uniform" }, [
                  _c(
                    "div",
                    [
                      _c("cargo-pagination", {
                        attrs: {
                          "config-module": "41001220015",
                          total: _vm.externalPaging.total,
                          page: _vm.externalPaging.pageNum,
                          limit: _vm.externalPaging.pageSize
                        },
                        on: {
                          "update:page": function($event) {
                            return _vm.$set(
                              _vm.externalPaging,
                              "pageNum",
                              $event
                            )
                          },
                          "update:limit": function($event) {
                            return _vm.$set(
                              _vm.externalPaging,
                              "pageSize",
                              $event
                            )
                          },
                          pagination: function($event) {
                            return _vm.checkDetails()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.externalPaging.total !== 0,
                          expression: "externalPaging.total !== 0"
                        }
                      ],
                      staticClass: "combined"
                    },
                    _vm._l(_vm.externalAmountList, function(item, index) {
                      return _c("p", { key: index, staticClass: "usd" }, [
                        _vm._v(" 共" + _vm._s(item.total) + "笔， "),
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(_vm._s(item.currency) + "：")
                        ]),
                        _c(
                          "span",
                          { staticStyle: { "font-style": "oblique" } },
                          [_vm._v(_vm._s(item.amount.toFixed(2)))]
                        )
                      ])
                    }),
                    0
                  )
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("Clearing.SystemInternalFees")))
                ]),
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "2022061602",
                    "grid-options": _vm.internalGridOptions,
                    "column-defs": _vm.internalColumnDefs,
                    "row-data": _vm.internalData
                  }
                }),
                _c("div", { staticClass: "uniform" }, [
                  _c(
                    "div",
                    [
                      _c("cargo-pagination", {
                        attrs: {
                          "config-module": "41001220016",
                          total: _vm.internalPaging.total,
                          page: _vm.internalPaging.pageNum,
                          limit: _vm.internalPaging.pageSize
                        },
                        on: {
                          "update:page": function($event) {
                            return _vm.$set(
                              _vm.internalPaging,
                              "pageNum",
                              $event
                            )
                          },
                          "update:limit": function($event) {
                            return _vm.$set(
                              _vm.internalPaging,
                              "pageSize",
                              $event
                            )
                          },
                          pagination: function($event) {
                            return _vm.checkDetails()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.internalPaging.total !== 0,
                          expression: "internalPaging.total !== 0"
                        }
                      ],
                      staticClass: "combined"
                    },
                    _vm._l(_vm.internalAmountList, function(item, index) {
                      return _c("p", { key: index, staticClass: "usd" }, [
                        _vm._v(" 共" + _vm._s(item.total) + "笔， "),
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(_vm._s(item.currency) + "：")
                        ]),
                        _c(
                          "span",
                          { staticStyle: { "font-style": "oblique" } },
                          [_vm._v(_vm._s(item.amount.toFixed(2)))]
                        )
                      ])
                    }),
                    0
                  )
                ])
              ],
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }